export function singleFlight(ref, task) {
  if (ref.current) return ref.current;
  const request = Promise.resolve()
    .then(task)
    .finally(() => {
      if (ref.current === request) ref.current = null;
    });
  ref.current = request;
  return request;
}

export function createKeyedSingleFlight() {
  const requests = new Map();

  return (key, task) => {
    if (requests.has(key)) return requests.get(key);

    const request = Promise.resolve()
      .then(task)
      .finally(() => {
        if (requests.get(key) === request) requests.delete(key);
      });

    requests.set(key, request);
    return request;
  };
}
